import * as R from 'ramda';

export const formatNewForm = (form, { profile }) => {
    const { userName, organizations } = profile;
    const organizationIds = form.publish === 'SPECIFIC-ORGANIZATIONS' ? form.organizationIds : R.pluck('id')(organizations);
    return R.merge(form, { userName, organizationIds });
};

export const trimName = (form) => {
  const transformations = { name: R.trim };
  return R.evolve(transformations, form);
}

export const formatFormSettingsData = (formData, selectedForm, organizations, userName) => {
    return R.pipe(
        R.evolve({name: R.trim}),    // trim whitespace from name
        R.assoc('lastModifiedUserName', userName),  // add last modified as user who is making mods
        checkOrganizationIds(selectedForm, organizations)  // check to see what orgIds should be added (if any)
    )(formData);
}

export const formatFormCopyData = (formData, selectedForm, organizations, userName, userId) => {
    return R.pipe(
        R.evolve({name: R.trim}),
        R.assoc('userName', userName),
        R.assoc('userId', userId),
        checkOrganizationIds(selectedForm, organizations)
    )(formData);
}

export const isFormOwner = (form, userId) => {
    return form && (form.createdBy.userId === userId);
}

function checkOrganizationIds (selectedForm, organizations) {
    return (formData) => {
        // Check to see if orgIds is part of the data the user edited
        const updateOrgIds = R.has('organizationIds');
        // If orgIds have been edited, or if publish has been edited and is NOT NOBODY, then add orgs to data
        const addOrgs = R.anyPass([updateOrgIds, checkPublish]);
        // Get correct value to send for orgIds based on form data fields
        const organizationIds = getOrganizationIds(formData, selectedForm, organizations);
        // If orgIds should be added, add them to formData as organizationIds
        return R.when(addOrgs, R.assoc('organizationIds', organizationIds))(formData);
    }
}

function checkPublish (formData) {
    const hasPublish = R.has('publish'); // Check if user has edited publish value
    const publishNotNobody = R.propSatisfies(x => x !== 'NO', 'publish'); // if publish === NOBODY don't include orgIds
    return R.allPass([hasPublish, publishNotNobody])(formData); // return if each of these is truthy
}

function getOrganizationIds (formData, selectedForm, organizations) {
    if (formData.organizationIds) {
        // If the user edited orgIds, then use the values from the form data they edited
        return formData.organizationIds;
    } else if (formData.publish && formData.publish === 'SPECIFIC-ORGANIZATIONS') {
        // If the user did not edit orgIds, but changed the publish value to SPECIFIC-ORGANIZATIONS,
        // then add orgIds from the selected form
        return selectedForm.organizationIds;
    } else {
        // If neither condition above, then user changed publish to a value that should contain
        // the list of all orgIds the user is associated with in the user data
        return R.pluck('id')(organizations);
    }
}
